import { FilterType, ICreateFilterDTO, IFilterLocale } from '@/models/filters.model';

class CreateFilterDTO implements ICreateFilterDTO {
  position: number;
  locale: IFilterLocale;
  type: FilterType;
  is_active: boolean;
  filterable: boolean;
  required: boolean;
  slug?: string;
  categories?: string[];

  constructor({
    position,
    locale,
    type,
    is_active,
    filterable,
    required,
    slug,
    categories,
  }: {
    position: number;
    locale: IFilterLocale;
    type: FilterType;
    is_active: boolean;
    filterable: boolean;
    required: boolean;
    slug?: string;
    categories?: string[];
  }) {
    this.position = position;
    this.locale = locale;
    this.type = type;
    this.is_active = is_active;
    this.filterable = filterable;
    this.required = required;
    this.slug = slug;

    if (categories) {
      this.categories = categories;
    }
  }
}

export default CreateFilterDTO;
